import { preprocess } from '@artica/assets';
import formatSpiral from '../../common/formatSpiral';

preprocess('spiral', function preprocessSpiral(asset) {
  const group = formatSpiral(asset);
  
  // const spirals = group.children[0];
  // const vertical = group.children[1];
  const rings = group.children[2];
  rings.scale.x = 1.2;
  rings.scale.y = 1.2;
  rings.scale.z = 1.2;
  
  return group;
});